module.exports = __webpack_public_path__ + "static/img/eunike.caa5710.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/testimonial/eunike.jpeg
// module id = mS3h
// module chunks = 1